import { StyledFlex } from '@dreryk/react-components';

import { usePatientDependenciesContext } from '../../dependencies';
import { patientTranslationKeys } from '../../translations';

type OptionsCellProps = {
   readonly patientId: number;
};

export const OptionsCell = (props: OptionsCellProps): JSX.Element => {
   const {
      appointmentOutOfScheduleButton: AppointmentOutOfScheduleButton,
      visitsHistoryButton: VisitsHistoryButton,
      accountConfigurationVerificationEventInterceptor,
   } = usePatientDependenciesContext();

   return (
      <StyledFlex gap={4}>
         {AppointmentOutOfScheduleButton ? (
            <AppointmentOutOfScheduleButton
               patientId={props.patientId}
               accountConfigurationVerificationEventInterceptor={accountConfigurationVerificationEventInterceptor}
               goBackButtonLabel={patientTranslationKeys.goBackToPatientList}
            />
         ) : null}
         <VisitsHistoryButton patientId={props.patientId} />
      </StyledFlex>
   );
};
